var _defs, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgSpiked2 = function SvgSpiked2(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "spiked_2_svg__spiked",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 403 696",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".spiked_2_svg__cls-1{fill:url(#spiked_2_svg__radial-gradient-99)}.spiked_2_svg__cls-2{fill:url(#spiked_2_svg__radial-gradient-39)}.spiked_2_svg__cls-3{fill:url(#spiked_2_svg__radial-gradient-46)}.spiked_2_svg__cls-4{fill:url(#spiked_2_svg__radial-gradient-120)}.spiked_2_svg__cls-5{fill:url(#spiked_2_svg__radial-gradient-128)}.spiked_2_svg__cls-6{fill:url(#spiked_2_svg__radial-gradient-7)}.spiked_2_svg__cls-7{fill:url(#spiked_2_svg__radial-gradient-91)}.spiked_2_svg__cls-8{fill:url(#spiked_2_svg__radial-gradient-34)}.spiked_2_svg__cls-9{fill:url(#spiked_2_svg__radial-gradient-10)}.spiked_2_svg__cls-10{fill:url(#spiked_2_svg__radial-gradient-47)}.spiked_2_svg__cls-11{fill:url(#spiked_2_svg__radial-gradient-125)}.spiked_2_svg__cls-12{fill:url(#spiked_2_svg__radial-gradient-48)}.spiked_2_svg__cls-13{fill:url(#spiked_2_svg__radial-gradient-31)}.spiked_2_svg__cls-14{fill:url(#spiked_2_svg__radial-gradient-72)}.spiked_2_svg__cls-15{fill:url(#spiked_2_svg__radial-gradient-100)}.spiked_2_svg__cls-16{fill:url(#spiked_2_svg__radial-gradient-146)}.spiked_2_svg__cls-17{fill:url(#spiked_2_svg__radial-gradient-94)}.spiked_2_svg__cls-18{fill:url(#spiked_2_svg__radial-gradient-111)}.spiked_2_svg__cls-19{fill:url(#spiked_2_svg__radial-gradient-101)}.spiked_2_svg__cls-20{fill:url(#spiked_2_svg__radial-gradient-108)}.spiked_2_svg__cls-21{fill:url(#spiked_2_svg__radial-gradient-28)}.spiked_2_svg__cls-22{fill:url(#spiked_2_svg__radial-gradient-103)}.spiked_2_svg__cls-23{fill:url(#spiked_2_svg__radial-gradient-89)}.spiked_2_svg__cls-24{fill:url(#spiked_2_svg__radial-gradient-116)}.spiked_2_svg__cls-25{fill:url(#spiked_2_svg__radial-gradient-65)}.spiked_2_svg__cls-26{fill:url(#spiked_2_svg__radial-gradient-16)}.spiked_2_svg__cls-27{fill:url(#spiked_2_svg__radial-gradient-57)}.spiked_2_svg__cls-28{fill:url(#spiked_2_svg__radial-gradient-144)}.spiked_2_svg__cls-29{fill:url(#spiked_2_svg__radial-gradient-140)}.spiked_2_svg__cls-30{fill:url(#spiked_2_svg__radial-gradient-50)}.spiked_2_svg__cls-31{fill:url(#spiked_2_svg__radial-gradient-20)}.spiked_2_svg__cls-32{fill:url(#spiked_2_svg__radial-gradient-21)}.spiked_2_svg__cls-33{fill:url(#spiked_2_svg__radial-gradient-8)}.spiked_2_svg__cls-34{fill:url(#spiked_2_svg__radial-gradient-119)}.spiked_2_svg__cls-35{fill:url(#spiked_2_svg__radial-gradient-126)}.spiked_2_svg__cls-36{fill:url(#spiked_2_svg__radial-gradient-5)}.spiked_2_svg__cls-37{fill:url(#spiked_2_svg__radial-gradient-98)}.spiked_2_svg__cls-38{fill:url(#spiked_2_svg__radial-gradient-4)}.spiked_2_svg__cls-39{fill:url(#spiked_2_svg__radial-gradient-88)}.spiked_2_svg__cls-40{fill:url(#spiked_2_svg__radial-gradient-121)}.spiked_2_svg__cls-41{fill:url(#spiked_2_svg__radial-gradient-90)}.spiked_2_svg__cls-42{fill:url(#spiked_2_svg__radial-gradient-67)}.spiked_2_svg__cls-43{fill:url(#spiked_2_svg__radial-gradient-68)}.spiked_2_svg__cls-44{fill:url(#spiked_2_svg__radial-gradient-40)}.spiked_2_svg__cls-45{fill:url(#spiked_2_svg__radial-gradient-114)}.spiked_2_svg__cls-46{fill:url(#spiked_2_svg__radial-gradient-96)}.spiked_2_svg__cls-47{fill:url(#spiked_2_svg__radial-gradient-64)}.spiked_2_svg__cls-48{fill:url(#spiked_2_svg__radial-gradient-148)}.spiked_2_svg__cls-49{fill:url(#spiked_2_svg__radial-gradient-97)}.spiked_2_svg__cls-50{fill:url(#spiked_2_svg__radial-gradient-32)}.spiked_2_svg__cls-51{fill:url(#spiked_2_svg__radial-gradient-147)}.spiked_2_svg__cls-52{fill:url(#spiked_2_svg__radial-gradient-78)}.spiked_2_svg__cls-53{fill:url(#spiked_2_svg__radial-gradient-52)}.spiked_2_svg__cls-54{fill:url(#spiked_2_svg__radial-gradient-54)}.spiked_2_svg__cls-55{fill:url(#spiked_2_svg__radial-gradient-76)}.spiked_2_svg__cls-56{fill:url(#spiked_2_svg__radial-gradient-25)}.spiked_2_svg__cls-57{fill:url(#spiked_2_svg__radial-gradient-26)}.spiked_2_svg__cls-58{fill:url(#spiked_2_svg__radial-gradient-136)}.spiked_2_svg__cls-59{fill:url(#spiked_2_svg__radial-gradient-142)}.spiked_2_svg__cls-60{fill:url(#spiked_2_svg__radial-gradient-22)}.spiked_2_svg__cls-61{fill:url(#spiked_2_svg__radial-gradient-6)}.spiked_2_svg__cls-62{fill:url(#spiked_2_svg__radial-gradient-19)}.spiked_2_svg__cls-63{fill:url(#spiked_2_svg__radial-gradient-60)}.spiked_2_svg__cls-64{fill:url(#spiked_2_svg__radial-gradient-110)}.spiked_2_svg__cls-65{fill:url(#spiked_2_svg__radial-gradient-12)}.spiked_2_svg__cls-66{fill:url(#spiked_2_svg__radial-gradient-135)}.spiked_2_svg__cls-67{fill:url(#spiked_2_svg__radial-gradient-55)}.spiked_2_svg__cls-68{fill:url(#spiked_2_svg__radial-gradient-49)}.spiked_2_svg__cls-69{fill:url(#spiked_2_svg__radial-gradient-41)}.spiked_2_svg__cls-70{fill:url(#spiked_2_svg__radial-gradient-35)}.spiked_2_svg__cls-71{fill:url(#spiked_2_svg__radial-gradient)}.spiked_2_svg__cls-72{fill:url(#spiked_2_svg__radial-gradient-75)}.spiked_2_svg__cls-73{fill:url(#spiked_2_svg__radial-gradient-79)}.spiked_2_svg__cls-74{fill:url(#spiked_2_svg__radial-gradient-81)}.spiked_2_svg__cls-75{opacity:.4}.spiked_2_svg__cls-76{fill:url(#spiked_2_svg__radial-gradient-123)}.spiked_2_svg__cls-77{fill:url(#spiked_2_svg__radial-gradient-27)}.spiked_2_svg__cls-78{fill:url(#spiked_2_svg__radial-gradient-13)}.spiked_2_svg__cls-79{fill:url(#spiked_2_svg__radial-gradient-69)}.spiked_2_svg__cls-80{fill:url(#spiked_2_svg__radial-gradient-102)}.spiked_2_svg__cls-81{fill:url(#spiked_2_svg__radial-gradient-105)}.spiked_2_svg__cls-82{fill:url(#spiked_2_svg__radial-gradient-141)}.spiked_2_svg__cls-83{fill:url(#spiked_2_svg__radial-gradient-145)}.spiked_2_svg__cls-84{fill:url(#spiked_2_svg__radial-gradient-130)}.spiked_2_svg__cls-85{fill:url(#spiked_2_svg__radial-gradient-129)}.spiked_2_svg__cls-86{fill:url(#spiked_2_svg__radial-gradient-74)}.spiked_2_svg__cls-87{fill:url(#spiked_2_svg__radial-gradient-109)}.spiked_2_svg__cls-88{fill:url(#spiked_2_svg__radial-gradient-127)}.spiked_2_svg__cls-89{fill:url(#spiked_2_svg__radial-gradient-92)}.spiked_2_svg__cls-90{fill:url(#spiked_2_svg__radial-gradient-104)}.spiked_2_svg__cls-91{fill:url(#spiked_2_svg__radial-gradient-43)}.spiked_2_svg__cls-92{fill:url(#spiked_2_svg__radial-gradient-30)}.spiked_2_svg__cls-93{fill:url(#spiked_2_svg__radial-gradient-66)}.spiked_2_svg__cls-94{fill:url(#spiked_2_svg__radial-gradient-118)}.spiked_2_svg__cls-95{fill:url(#spiked_2_svg__radial-gradient-86)}.spiked_2_svg__cls-96{fill:url(#spiked_2_svg__radial-gradient-95)}.spiked_2_svg__cls-97{fill:url(#spiked_2_svg__radial-gradient-51)}.spiked_2_svg__cls-98{fill:url(#spiked_2_svg__radial-gradient-61)}.spiked_2_svg__cls-99{fill:url(#spiked_2_svg__radial-gradient-24)}.spiked_2_svg__cls-100{fill:url(#spiked_2_svg__radial-gradient-58)}.spiked_2_svg__cls-101{fill:url(#spiked_2_svg__radial-gradient-87)}.spiked_2_svg__cls-102{fill:url(#spiked_2_svg__radial-gradient-15)}.spiked_2_svg__cls-103{fill:url(#spiked_2_svg__radial-gradient-2)}.spiked_2_svg__cls-104{fill:url(#spiked_2_svg__radial-gradient-133)}.spiked_2_svg__cls-105{fill:url(#spiked_2_svg__radial-gradient-143)}.spiked_2_svg__cls-106{fill:url(#spiked_2_svg__radial-gradient-93)}.spiked_2_svg__cls-107{fill:url(#spiked_2_svg__radial-gradient-106)}.spiked_2_svg__cls-108{fill:url(#spiked_2_svg__radial-gradient-122)}.spiked_2_svg__cls-109{fill:url(#spiked_2_svg__radial-gradient-38)}.spiked_2_svg__cls-110{fill:url(#spiked_2_svg__radial-gradient-3)}.spiked_2_svg__cls-111{fill:url(#spiked_2_svg__radial-gradient-80)}.spiked_2_svg__cls-112{fill:url(#spiked_2_svg__radial-gradient-56)}.spiked_2_svg__cls-113{fill:url(#spiked_2_svg__radial-gradient-42)}.spiked_2_svg__cls-114{fill:url(#spiked_2_svg__radial-gradient-124)}.spiked_2_svg__cls-115{fill:url(#spiked_2_svg__radial-gradient-53)}.spiked_2_svg__cls-116{fill:url(#spiked_2_svg__radial-gradient-115)}.spiked_2_svg__cls-117{fill:url(#spiked_2_svg__radial-gradient-139)}.spiked_2_svg__cls-118{fill:url(#spiked_2_svg__radial-gradient-149)}.spiked_2_svg__cls-119{fill:url(#spiked_2_svg__radial-gradient-45)}.spiked_2_svg__cls-120{fill:url(#spiked_2_svg__radial-gradient-17)}.spiked_2_svg__cls-121{fill:url(#spiked_2_svg__radial-gradient-85)}.spiked_2_svg__cls-122{fill:url(#spiked_2_svg__radial-gradient-33)}.spiked_2_svg__cls-123{fill:url(#spiked_2_svg__radial-gradient-84)}.spiked_2_svg__cls-124{fill:url(#spiked_2_svg__radial-gradient-14)}.spiked_2_svg__cls-125{fill:url(#spiked_2_svg__radial-gradient-83)}.spiked_2_svg__cls-126{fill:url(#spiked_2_svg__radial-gradient-107)}.spiked_2_svg__cls-127{fill:url(#spiked_2_svg__radial-gradient-131)}.spiked_2_svg__cls-128{fill:url(#spiked_2_svg__radial-gradient-113)}.spiked_2_svg__cls-129{fill:url(#spiked_2_svg__radial-gradient-117)}.spiked_2_svg__cls-130{fill:url(#spiked_2_svg__radial-gradient-37)}.spiked_2_svg__cls-131{fill:url(#spiked_2_svg__radial-gradient-71)}.spiked_2_svg__cls-132{fill:url(#spiked_2_svg__radial-gradient-137)}.spiked_2_svg__cls-133{fill:url(#spiked_2_svg__radial-gradient-29)}.spiked_2_svg__cls-134{fill:url(#spiked_2_svg__radial-gradient-62)}.spiked_2_svg__cls-135{fill:url(#spiked_2_svg__radial-gradient-82)}.spiked_2_svg__cls-136{fill:url(#spiked_2_svg__radial-gradient-112)}.spiked_2_svg__cls-137{fill:url(#spiked_2_svg__radial-gradient-138)}.spiked_2_svg__cls-138{fill:url(#spiked_2_svg__radial-gradient-134)}.spiked_2_svg__cls-139{fill:url(#spiked_2_svg__radial-gradient-59)}.spiked_2_svg__cls-140{fill:url(#spiked_2_svg__radial-gradient-23)}.spiked_2_svg__cls-141{fill:url(#spiked_2_svg__radial-gradient-63)}.spiked_2_svg__cls-142{fill:url(#spiked_2_svg__radial-gradient-36)}.spiked_2_svg__cls-143{fill:url(#spiked_2_svg__radial-gradient-70)}.spiked_2_svg__cls-144{fill:url(#spiked_2_svg__radial-gradient-11)}.spiked_2_svg__cls-145{fill:url(#spiked_2_svg__radial-gradient-18)}.spiked_2_svg__cls-146{fill:url(#spiked_2_svg__radial-gradient-77)}.spiked_2_svg__cls-147{fill:url(#spiked_2_svg__radial-gradient-9)}.spiked_2_svg__cls-148{fill:#f2f2f2}.spiked_2_svg__cls-149{fill:url(#spiked_2_svg__radial-gradient-73)}.spiked_2_svg__cls-150{fill:url(#spiked_2_svg__radial-gradient-44)}.spiked_2_svg__cls-151{fill:url(#spiked_2_svg__radial-gradient-132)}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient",
    cx: 409.1868,
    cy: 624.3846,
    fx: 409.1868,
    fy: 624.3846,
    r: 536.1415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8d5dcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#936bcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9aaaf3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-2",
    cx: -98.8047,
    cy: 259.4525,
    fx: -98.8047,
    fy: 259.4525,
    r: 437.6559,
    gradientTransform: "translate(1.0989 -.1136)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a2bef1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7047,
    stopColor: "#ae7edb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b463d2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-3",
    cx: -79.6539,
    cy: 318.2398,
    fx: -79.6539,
    fy: 318.2398,
    r: 273.503,
    gradientTransform: "translate(1.0989 -.1136)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aba8f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ac7ed2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-4",
    cx: -89.8161,
    cy: 270.6986,
    fx: -89.8161,
    fy: 270.6986,
    r: 238.6051,
    gradientTransform: "translate(1.0989 -.1136)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a2bef1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8379,
    stopColor: "#aa7ed7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ac72d2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-5",
    cx: -184.9563,
    cy: 250.8225,
    fx: -184.9563,
    fy: 250.8225,
    r: 356.5263,
    gradientTransform: "translate(1.0989 -.1136)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d57c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2033,
    stopColor: "#5158c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4095,
    stopColor: "#5d5dc8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617,
    stopColor: "#7165ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    stopColor: "#8d71ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ac7ed2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-6",
    cx: 271.0372,
    cy: 70.6166,
    fx: 271.0372,
    fy: 70.6166,
    r: 227.3131,
    xlinkHref: "#spiked_2_svg__radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-7",
    cx: 196.7878,
    cy: 26.798,
    fx: 196.7878,
    fy: 26.798,
    r: 152.7697,
    gradientTransform: "translate(1.0989 -.1136)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d57c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6762,
    stopColor: "#8c70cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ac7ed2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-8",
    cx: 209.4021,
    cy: 165.523,
    fx: 209.4021,
    fy: 165.523,
    r: 217.1576,
    gradientTransform: "translate(1.0989 -.1136)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d57c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b4b9d9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-9",
    cx: 86.2589,
    cy: 55.7338,
    fx: 86.2589,
    fy: 55.7338,
    r: 232.4369,
    gradientTransform: "translate(1.0989 -.1136)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#94baff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ac7ed2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-10",
    cx: 99.1865,
    cy: 35.765,
    fx: 99.1865,
    fy: 35.765,
    r: 241.8562,
    xlinkHref: "#spiked_2_svg__radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-11",
    cx: 413.2018,
    cy: 577.2462,
    fx: 413.2018,
    fy: 577.2462,
    r: 556.621,
    gradientTransform: "translate(1.0989 -.1136)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c976d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5a51c7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-12",
    cx: 323.9827,
    cy: 549.0716,
    fx: 323.9827,
    fy: 549.0716,
    r: 437.9876,
    gradientTransform: "translate(1.0989 -.1136)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9962c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7955e0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-13",
    cx: 182.2001,
    cy: 709.5516,
    fx: 182.2001,
    fy: 709.5516,
    r: 442.741,
    gradientTransform: "translate(1.0989 -.1136)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c976d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7667d1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-14",
    cx: -164.3689,
    cy: 341.0782,
    fx: -164.3689,
    fy: 341.0782,
    r: 332.5324,
    xlinkHref: "#spiked_2_svg__radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-15",
    cx: 50.4659,
    cy: 190.9499,
    fx: 50.4659,
    fy: 190.9499,
    r: 175.1473,
    gradientTransform: "translate(1.0989 -.1136)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#878ed6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ac7ed2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-16",
    cx: 21.3589,
    cy: 600.6165,
    fx: 21.3589,
    fy: 600.6165,
    r: 149.8704,
    gradientTransform: "translate(1.0989 -.1136)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9f4bc1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9563da"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-17",
    cx: -21.6267,
    cy: 568.0126,
    fx: -21.6267,
    fy: 568.0126,
    r: 388.9741,
    gradientTransform: "translate(1.0989 -.1136)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7955e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9962c1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-18",
    cx: 246.8927,
    cy: 701.702,
    fx: 246.8927,
    fy: 701.702,
    r: 187.7417,
    gradientTransform: "translate(1.0989 -.1136)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#984bc1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a768de"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-19",
    cx: 235.358,
    cy: 665.5979,
    fx: 235.358,
    fy: 665.5979,
    r: 141.122,
    gradientTransform: "translate(1.0989 -.1136)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9962c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9d59e0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-20",
    cx: 361.4095,
    cy: 620.4663,
    fx: 361.4095,
    fy: 620.4663,
    r: 287.7812,
    gradientTransform: "translate(1.0989 -.1136)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9962c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a768de"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-21",
    cx: 379.8856,
    cy: 374.9012,
    fx: 379.8856,
    fy: 374.9012,
    r: 316.6745,
    gradientTransform: "translate(1.0989 -.1136)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c976d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7365c7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-22",
    cx: -95.6335,
    cy: 520.6011,
    fx: -95.6335,
    fy: 520.6011,
    r: 295.1596,
    xlinkHref: "#spiked_2_svg__radial-gradient-16"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-23",
    cx: 168.3466,
    cy: 686.2033,
    fx: 168.3466,
    fy: 686.2033,
    r: 59.1016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3c62db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0734,
    stopColor: "#3f69d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#5eaac6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6ac4bf"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-24",
    cx: 221.794,
    cy: 717.5131,
    fx: 221.794,
    fy: 717.5131,
    r: 104.0951,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-25",
    cx: 157.2802,
    cy: 629.8297,
    fx: 157.2802,
    fy: 629.8297,
    r: 43.2246,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-26",
    cx: 231.134,
    cy: 631.0202,
    fx: 231.134,
    fy: 631.0202,
    r: 42.4455,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-27",
    cx: 161.8297,
    cy: 588.8736,
    fx: 161.8297,
    fy: 588.8736,
    r: 35.7234,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-28",
    cx: 210.0728,
    cy: 579.9725,
    fx: 210.0728,
    fy: 579.9725,
    r: 43.9192,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-29",
    cx: 385.1364,
    cy: 311.3333,
    fx: 385.1364,
    fy: 311.3333,
    r: 64.1745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3c62db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    stopColor: "#4474d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7301,
    stopColor: "#61b5c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6dcfc3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-30",
    cx: 373.9491,
    cy: 343.9083,
    fx: 373.9491,
    fy: 343.9083,
    r: 106.2327,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-31",
    cx: 359.5954,
    cy: 333.5879,
    fx: 359.5954,
    fy: 333.5879,
    r: 70.7149,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-32",
    cx: 254.3736,
    cy: 276.3846,
    fx: 254.3736,
    fy: 276.3846,
    r: 80.9116,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-33",
    cx: 263.2088,
    cy: 284.8901,
    fx: 263.2088,
    fy: 284.8901,
    r: 79.1765,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-34",
    cx: 314.4122,
    cy: 345.7473,
    fx: 314.4122,
    fy: 345.7473,
    r: 64.0919,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-35",
    cx: 228.7912,
    cy: 547.5055,
    fx: 228.7912,
    fy: 547.5055,
    r: 85.6445,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-36",
    cx: 145.978,
    cy: 423.2857,
    fx: 145.978,
    fy: 423.2857,
    r: 77.2211,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-37",
    cx: 147.5604,
    cy: 445.4396,
    fx: 147.5604,
    fy: 445.4396,
    r: 60.9739,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-38",
    cx: 266.2418,
    cy: 415.1099,
    fx: 266.2418,
    fy: 415.1099,
    r: 107.0769,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-39",
    cx: 243.8912,
    cy: 279.5943,
    fx: 243.8912,
    fy: 279.5943,
    r: 80.9282,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-40",
    cx: 348.4293,
    cy: 322.3022,
    fx: 348.4293,
    fy: 322.3022,
    r: 61.9247,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-41",
    cx: 336.4992,
    cy: 636.2527,
    fx: 336.4992,
    fy: 636.2527,
    r: 96.5524,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-42",
    cx: 295.2527,
    cy: 594.7947,
    fx: 295.2527,
    fy: 594.7947,
    r: 58.6795,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-43",
    cx: 298.8132,
    cy: 553.6363,
    fx: 298.8132,
    fy: 553.6363,
    r: 74.5491,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-44",
    cx: 176.967,
    cy: 657.3974,
    fx: 176.967,
    fy: 657.3974,
    r: 105.8913,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-45",
    cx: 180.8706,
    cy: 583.7992,
    fx: 180.8706,
    fy: 583.7992,
    r: 47.3504,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-46",
    cx: 168.6593,
    cy: 684.9121,
    fx: 168.6593,
    fy: 684.9121,
    r: 114.5922,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-47",
    cx: 186.8571,
    cy: 521.1319,
    fx: 186.8571,
    fy: 521.1319,
    r: 53.4666,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-48",
    cx: 303.9353,
    cy: 699.5104,
    fx: 303.9353,
    fy: 699.5104,
    r: 56.392,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-49",
    cx: 359.478,
    cy: 573.3062,
    fx: 359.478,
    fy: 573.3062,
    r: 80.3113,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-50",
    cx: 167.6254,
    cy: 585.3077,
    fx: 167.6254,
    fy: 585.3077,
    r: 178.6422,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-51",
    cx: 366.9615,
    cy: 530.8316,
    fx: 366.9615,
    fy: 530.8316,
    r: 83.2043,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-52",
    cx: 229.9505,
    cy: 582.7189,
    fx: 229.9505,
    fy: 582.7189,
    r: 81.5695,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-53",
    cx: 246.8848,
    cy: 521.2255,
    fx: 246.8848,
    fy: 521.2255,
    r: 54.2439,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-54",
    cx: 236.9868,
    cy: 498.2609,
    fx: 236.9868,
    fy: 498.2609,
    r: 66.5182,
    gradientTransform: "translate(-17.592 10.1443) rotate(-1.9516)",
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-55",
    cx: 340.456,
    cy: 477.2714,
    fx: 340.456,
    fy: 477.2714,
    r: 70.9965,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-56",
    cx: 224.1247,
    cy: 648.4914,
    fx: 224.1247,
    fy: 648.4914,
    r: 142.0439,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-57",
    cx: 374.2382,
    cy: 575.5902,
    fx: 374.2382,
    fy: 575.5902,
    r: 88.2792,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-58",
    cx: 201.9902,
    cy: 612.4454,
    fx: 201.9902,
    fy: 612.4454,
    r: 157.3997,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-59",
    cx: 356.9038,
    cy: 612.6167,
    fx: 356.9038,
    fy: 612.6167,
    r: 74.4405,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-60",
    cx: 267.0227,
    cy: 630.9734,
    fx: 267.0227,
    fy: 630.9734,
    r: 94.0171,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-61",
    cx: 267.1606,
    cy: 633.3242,
    fx: 267.1606,
    fy: 633.3242,
    r: 108.7461,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-62",
    cx: 282.3022,
    cy: 485.2145,
    fx: 282.3022,
    fy: 485.2145,
    r: 53.5951,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-63",
    cx: 368.1484,
    cy: 427.478,
    fx: 368.1484,
    fy: 427.478,
    r: 104.8352,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-64",
    cx: 392.3969,
    cy: 365.8368,
    fx: 392.3969,
    fy: 365.8368,
    r: 150.355,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-65",
    cx: 243.344,
    cy: 462.9554,
    fx: 243.344,
    fy: 462.9554,
    r: 65.4485,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-66",
    cx: 427.6729,
    cy: 541.828,
    fx: 427.6729,
    fy: 541.828,
    r: 61.9402,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-67",
    cx: 304.0604,
    cy: 487.7967,
    fx: 304.0604,
    fy: 487.7967,
    r: 64.1343,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-68",
    cx: 298.2582,
    cy: 502.9066,
    fx: 298.2582,
    fy: 502.9066,
    r: 95.0258,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-69",
    cx: 526.2857,
    cy: 477.2198,
    fx: 526.2857,
    fy: 477.2198,
    r: 183.6495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3c62db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0968,
    stopColor: "#4479d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2457,
    stopColor: "#4f97cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4035,
    stopColor: "#57aec8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5721,
    stopColor: "#5dbfc4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7588,
    stopColor: "#60c8c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62ccc1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-70",
    cx: 316.6154,
    cy: 377.1319,
    fx: 316.6154,
    fy: 377.1319,
    r: 71.3756,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-71",
    cx: 289.7143,
    cy: 449.9231,
    fx: 289.7143,
    fy: 449.9231,
    r: 61.7257,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-72",
    cx: 305.1429,
    cy: 372.7802,
    fx: 305.1429,
    fy: 372.7802,
    r: 73.7365,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-73",
    cx: 282.989,
    cy: 440.033,
    fx: 282.989,
    fy: 440.033,
    r: 66.6602,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-74",
    cx: 353.2473,
    cy: 453.437,
    fx: 353.2473,
    fy: 453.437,
    r: 55.2854,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-75",
    cx: 288.4292,
    cy: 521.5144,
    fx: 288.4292,
    fy: 521.5144,
    r: 42.936,
    gradientTransform: "translate(-6.6507 4.4089) rotate(-.7624)",
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-76",
    cx: 290.3695,
    cy: 523.3462,
    fx: 290.3695,
    fy: 523.3462,
    r: 47.7007,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-77",
    cx: 301.2912,
    cy: 539.8272,
    fx: 301.2912,
    fy: 539.8272,
    r: 52.2291,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-78",
    cx: 379.0932,
    cy: 500.4322,
    fx: 379.0932,
    fy: 500.4322,
    r: 39.8632,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-79",
    cx: 317.4957,
    cy: 551.7759,
    fx: 317.4957,
    fy: 551.7759,
    r: 53.1163,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-80",
    cx: 273.3759,
    cy: 500.7481,
    fx: 273.3759,
    fy: 500.7481,
    r: 54.1913,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-81",
    cx: 285.3901,
    cy: 500.469,
    fx: 285.3901,
    fy: 500.469,
    r: 45.6567,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-82",
    cx: 329.2088,
    cy: 464.951,
    fx: 329.2088,
    fy: 464.951,
    r: 43.1988,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-83",
    cx: 134.6374,
    cy: 641,
    fx: 134.6374,
    fy: 641,
    r: 124.1429,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-84",
    cx: 305.747,
    cy: 543.3415,
    fx: 305.747,
    fy: 543.3415,
    r: 108.2844,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-85",
    cx: 301.7567,
    cy: 593.8947,
    fx: 301.7567,
    fy: 593.8947,
    r: 108.9031,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-86",
    cx: 317.011,
    cy: 546.8462,
    fx: 317.011,
    fy: 546.8462,
    r: 103.501,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-87",
    cx: 168.0934,
    cy: 669.0265,
    fx: 168.0934,
    fy: 669.0265,
    r: 67.5976,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-88",
    cx: 289.3698,
    cy: 432.0147,
    fx: 289.3698,
    fy: 432.0147,
    r: 78.3453,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-89",
    cx: 192.1593,
    cy: 469.3027,
    fx: 192.1593,
    fy: 469.3027,
    r: 71.538,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-90",
    cx: 316.602,
    cy: 471.2705,
    fx: 316.602,
    fy: 471.2705,
    r: 106.6554,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-91",
    cx: 251.3476,
    cy: 513.8204,
    fx: 251.3476,
    fy: 513.8204,
    r: 46.6423,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-92",
    cx: 156.7995,
    cy: 552.0909,
    fx: 156.7995,
    fy: 552.0909,
    r: 28.7994,
    gradientTransform: "translate(395.2137 8.345) rotate(39.8381)",
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-93",
    cx: 221.6917,
    cy: 532.4716,
    fx: 221.6917,
    fy: 532.4716,
    r: 53.5713,
    gradientTransform: "translate(395.2137 8.345) rotate(39.8381)",
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-94",
    cx: 215.1892,
    cy: 560.3771,
    fx: 215.1892,
    fy: 560.3771,
    r: 44.0136,
    gradientTransform: "translate(395.2137 8.345) rotate(39.8381)",
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-95",
    cx: 198.3298,
    cy: 584.2204,
    fx: 198.3298,
    fy: 584.2204,
    r: 37.2079,
    gradientTransform: "translate(395.2137 8.345) rotate(39.8381)",
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-96",
    cx: 242.0096,
    cy: 418.9799,
    fx: 242.0096,
    fy: 418.9799,
    r: 47.926,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-97",
    cx: 358.3136,
    cy: 523.9828,
    fx: 358.3136,
    fy: 523.9828,
    r: 110.6626,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-98",
    cx: 387.764,
    cy: 432.004,
    fx: 387.764,
    fy: 432.004,
    r: 27.3973,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-99",
    cx: 353.6242,
    cy: 424.7622,
    fx: 353.6242,
    fy: 424.7622,
    r: 29.5493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3c62db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0734,
    stopColor: "#3f69d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#5eaac6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6ac4bf"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-100",
    cx: 405.2308,
    cy: 401.4615,
    fx: 405.2308,
    fy: 401.4615,
    r: 50.9002,
    xlinkHref: "#spiked_2_svg__radial-gradient-69"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-101",
    cx: 332.7071,
    cy: 411.6469,
    fx: 332.7071,
    fy: 411.6469,
    r: 35.0275,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-102",
    cx: 317.2447,
    cy: 403.654,
    fx: 317.2447,
    fy: 403.654,
    r: 28.9446,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-103",
    cx: 307.5891,
    cy: 340.6426,
    fx: 307.5891,
    fy: 340.6426,
    r: 62.43,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-104",
    cx: 317.911,
    cy: 401.0285,
    fx: 317.911,
    fy: 401.0285,
    r: 46.908,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-105",
    cx: 374.7544,
    cy: 325.2067,
    fx: 374.7544,
    fy: 325.2067,
    r: 70.708,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-106",
    cx: 327.609,
    cy: 360.58,
    fx: 327.609,
    fy: 360.58,
    r: 35.3062,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-107",
    cx: 306.5175,
    cy: 334.4827,
    fx: 306.5175,
    fy: 334.4827,
    r: 36.8232,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-108",
    cx: 360.8297,
    cy: 330.1484,
    fx: 360.8297,
    fy: 330.1484,
    r: 35.3009,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-109",
    cx: 313.1753,
    cy: 309.9545,
    fx: 313.1753,
    fy: 309.9545,
    r: 59.4258,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-110",
    cx: 313.1484,
    cy: 348.3571,
    fx: 313.1484,
    fy: 348.3571,
    r: 40.8513,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-111",
    cx: 346.349,
    cy: 318.7595,
    fx: 346.349,
    fy: 318.7595,
    r: 33.277,
    gradientTransform: "translate(-50.7103 61.8614) rotate(-9.9911)",
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-112",
    cx: 296.8808,
    cy: 325.9062,
    fx: 296.8808,
    fy: 325.9062,
    r: 34.9701,
    gradientTransform: "translate(-50.7103 61.8614) rotate(-9.9911)",
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-113",
    cx: 232.6538,
    cy: 402.0546,
    fx: 232.6538,
    fy: 402.0546,
    r: 25.0268,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-114",
    cx: 278.5177,
    cy: 397.2798,
    fx: 278.5177,
    fy: 397.2798,
    r: 44.4825,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-115",
    cx: 268.6972,
    cy: 396.7661,
    fx: 268.6972,
    fy: 396.7661,
    r: 37.7732,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-116",
    cx: 258.524,
    cy: 344.5592,
    fx: 258.524,
    fy: 344.5592,
    r: 28.4436,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-117",
    cx: 289.8179,
    cy: 351.0999,
    fx: 289.8179,
    fy: 351.0999,
    r: 69.3289,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-118",
    cx: 323.159,
    cy: 390.1183,
    fx: 323.159,
    fy: 390.1183,
    r: 29.3882,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-119",
    cx: 285.8717,
    cy: 393.0849,
    fx: 285.8717,
    fy: 393.0849,
    r: 35.7717,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-120",
    cx: 326.9637,
    cy: 370.8817,
    fx: 326.9637,
    fy: 370.8817,
    r: 30.2167,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-121",
    cx: 278.7418,
    cy: 383.9337,
    fx: 278.7418,
    fy: 383.9337,
    r: 32.8065,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-122",
    cx: 268.5401,
    cy: 355.6517,
    fx: 268.5401,
    fy: 355.6517,
    r: 46.9205,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-123",
    cx: 324.2613,
    cy: 358.7247,
    fx: 324.2613,
    fy: 358.7247,
    r: 38.514,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-124",
    cx: 296.3431,
    cy: 331.1459,
    fx: 296.3431,
    fy: 331.1459,
    r: 42.907,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-125",
    cx: 268.1792,
    cy: 344.1044,
    fx: 268.1792,
    fy: 344.1044,
    r: 43.8151,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-126",
    cx: 233.7814,
    cy: 326.4078,
    fx: 233.7814,
    fy: 326.4078,
    r: 43.9648,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-127",
    cx: 270.5976,
    cy: 281.3798,
    fx: 270.5976,
    fy: 281.3798,
    r: 46.5343,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-128",
    cx: 254.6278,
    cy: 317.643,
    fx: 254.6278,
    fy: 317.643,
    r: 33.8707,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-129",
    cx: 260.3468,
    cy: 352.2563,
    fx: 260.3468,
    fy: 352.2563,
    r: 51.7092,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-130",
    cx: 204.1022,
    cy: 326.145,
    fx: 204.1022,
    fy: 326.145,
    r: 24.2033,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-131",
    cx: 217.2208,
    cy: 368.6199,
    fx: 217.2208,
    fy: 368.6199,
    r: 41.1635,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-132",
    cx: 188.137,
    cy: 400.0495,
    fx: 188.137,
    fy: 400.0495,
    r: 43.9912,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-133",
    cx: 188.7112,
    cy: 362.7824,
    fx: 188.7112,
    fy: 362.7824,
    r: 18.3761,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-134",
    cx: 242.533,
    cy: 363.2463,
    fx: 242.533,
    fy: 363.2463,
    r: 46.8145,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-135",
    cx: 236.7308,
    cy: 388.9083,
    fx: 236.7308,
    fy: 388.9083,
    r: 46.9727,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-136",
    cx: 229.8756,
    cy: 449.9592,
    fx: 229.8756,
    fy: 449.9592,
    r: 50.1155,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-137",
    cx: 274.751,
    cy: 396.4212,
    fx: 274.751,
    fy: 396.4212,
    r: 102.6204,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-138",
    cx: 169.5635,
    cy: 437.6738,
    fx: 169.5635,
    fy: 437.6738,
    r: 59.5805,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-139",
    cx: 177.4641,
    cy: 675.1167,
    fx: 177.4641,
    fy: 675.1167,
    r: 55.9072,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-140",
    cx: 135.7582,
    cy: 632.6154,
    fx: 135.7582,
    fy: 632.6154,
    r: 38.9004,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-141",
    cx: 104.6663,
    cy: 627.6901,
    fx: 104.6663,
    fy: 627.6901,
    r: 41.4522,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-142",
    cx: 188.0127,
    cy: 668.8336,
    fx: 188.0127,
    fy: 668.8336,
    r: 50.781,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-143",
    cx: 134.0417,
    cy: 576.4121,
    fx: 134.0417,
    fy: 576.4121,
    r: 12.9388,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-144",
    cx: 189.5064,
    cy: 608.0604,
    fx: 189.5064,
    fy: 608.0604,
    r: 45.0702,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-145",
    cx: 127.4121,
    cy: 658.1439,
    fx: 127.4121,
    fy: 658.1439,
    r: 77.2854,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-146",
    cx: 172.891,
    cy: 622.7688,
    fx: 172.891,
    fy: 622.7688,
    r: 58.7831,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-147",
    cx: 183.129,
    cy: 625.3871,
    fx: 183.129,
    fy: 625.3871,
    r: 62.9165,
    gradientTransform: "translate(-16.2662 4.32) rotate(-1.5408)",
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-148",
    cx: 335.3407,
    cy: 413.1319,
    fx: 335.3407,
    fy: 413.1319,
    r: 50.4462,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spiked_2_svg__radial-gradient-149",
    cx: 232.7473,
    cy: 510.0549,
    fx: 232.7473,
    fy: 510.0549,
    r: 42.0347,
    xlinkHref: "#spiked_2_svg__radial-gradient-23"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "spiked_2_svg__purple-blue"
  }, /*#__PURE__*/React.createElement("g", {
    id: "spiked_2_svg__bg-6",
    "data-name": "bg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-71",
    d: "M340.5304,326.0749c.9669-8.8502,1.9337-17.7005,2.9006-26.5507-5.4788-7.5391-10.9577-15.0781-16.4365-22.6172-.6445-4.2612-1.2892-8.5225-1.9337-12.7837l5.8011-32.4508c-22.5599-45.8901-45.1197-91.7801-67.6796-137.6702-9.9908-3.9334-19.9815-7.8669-29.9724-11.8003-12.2467-25.5673-24.4936-51.1346-36.7403-76.702-18.3702,18.6838-36.7403,37.3676-55.1105,56.0514-8.0571,36.3843-16.1141,72.7685-24.1713,109.1528-37.0627,52.7736-74.1252,105.5471-111.1878,158.3207,13.5359,32.7786,27.0718,65.5572,40.6077,98.3359,4.8343,36.0564,9.6685,72.1129,14.5028,108.1694,22.2376,33.762,44.4751,67.5239,66.7127,101.2859,19.9815,6.2279,39.9632,12.4558,59.9448,18.6838,29.6501-10.8169,59.3002-21.6339,88.9503-32.4508,.6445-3.9334,1.2892-7.8669,1.9337-11.8003-1.6114-7.8669-3.2229-15.7337-4.8343-23.6006-.3223-3.9334-.6445-7.8669-.9669-11.8003,8.7017-11.1447,17.4033-22.2895,26.105-33.4342,4.1897-6.2279,8.3793-12.4559,12.5691-18.6838,.6445-3.6057,1.2892-7.2113,1.9337-10.8169,1.6114-1.639,3.2229-3.2778,4.8343-4.9168,1.6114-6.5557,3.2229-13.1114,4.8343-19.6672,5.8011-2.2945,11.6022-4.589,17.4033-6.8835,5.1566-5.9002,10.313-11.8003,15.4696-17.7005-5.1566-45.8901-10.313-91.7802-15.4696-137.6702Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "spiked_2_svg__shapes_color_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-103",
    d: "M114.976,168.0125c.6668,1.6666,1.3337,3.3331,2.0005,4.9997,2.6708,36.3328,5.3417,72.6657,8.0125,108.9985-39.9964,15.3395-79.9928,30.6791-119.9893,46.0187-1.6665,.3336-3.3331,.6672-4.9997,1.0008,38.3254-53.6725,76.6506-107.3451,114.976-161.0176Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-110",
    d: "M115.0006,378.012c-37.0002-15.3275-74.0003-30.655-111.0005-45.9826-1.3334-.9998-2.6667-1.9996-4.0002-2.9994,41.1629-15.8397,82.326-31.6795,123.4889-47.5192,.5001,1.1666,1.0002,2.3332,1.5003,3.4998-3.3296,31.0005-6.659,62.0009-9.9886,93.0014Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-38",
    d: "M0,329.0301c13.6699,33.3311,27.34,66.6623,41.0099,99.9934,.9999-.3335,1.9998-.667,2.9997-1.0005,22.9971-16.3369,45.9941-32.6738,68.9912-49.0107,.4999-.8334,.9998-1.6668,1.4996-2.5002-38.1668-15.8273-76.3337-31.6547-114.5005-47.482Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-36",
    d: "M114.5005,376.5121c.1668,1.5,.3337,2.9999,.5005,4.4999-18.6597,51.6695-37.3196,103.3389-55.9793,155.0084-.6665,1.0001-1.3331,2.0002-1.9996,3.0003-5.3374-36.6658-10.6748-73.3315-16.0122-109.9973,24.4969-17.5038,48.9937-35.0076,73.4906-52.5114Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-61",
    d: "M234.9601,77.9939c-.9999,.3335-1.9998,.667-2.9997,1.0005-13.998,11.6688-27.996,23.3377-41.994,35.0065-.6665,1.0001-1.3331,2.0002-1.9996,3.0003,1,.3332,2,.6664,3,.9995,24.3313-8.6705,48.6624-17.3409,72.9937-26.0114,.6665-.6668,1.3332-1.3335,1.9997-2.0003-10.3334-3.9984-20.6666-7.9968-31-11.9951Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-6",
    d: "M196.9526,0c-.3332,1.3334-.6663,2.6668-.9995,4.0001-2.9957,35.667-5.9914,71.3341-8.987,107.0012,.3336,1.9999,.6671,3.9999,1.0007,5.9998,15.6644-13.0024,31.3289-26.0048,46.9933-39.0073-12.6691-25.998-25.3384-51.9959-38.0075-77.9939Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-33",
    d: "M139.9618,57.0088c18.9969-19.0029,37.9938-38.0059,56.9908-57.0088-2.9953,39.0004-5.9906,78.0008-8.9859,117.0012l-1.9999,.0003c-15.3349-18.9976-30.6697-37.9951-46.0047-56.9927-.0001-1-.0002-2-.0004-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-147",
    d: "M188.9668,118.001c-3.994,49.6672-7.988,99.3344-11.982,149.0016-20.3362-31.9968-40.6723-63.9935-61.0086-95.9903-.3335-.9999-.6668-1.9999-1.0003-2.9998,8.3287-37.0012,16.6572-74.0024,24.9858-111.0037,16.335,20.3307,32.67,40.6615,49.005,60.9922Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-9",
    d: "M335.9735,229.9778l-7.9994,3.0012c-48.9966,10.0076-97.9932,20.0153-146.9899,30.0229l-4.9998,.0008c3.9942-48.6672,7.9882-97.3344,11.9823-146.0016,25.9978-9.004,51.9956-18.0081,77.9934-27.0121,23.3378,46.6629,46.6754,93.3258,70.0133,139.9888Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-144",
    d: "M185.9906,319.001c-3.3286,39.6671-6.657,79.3342-9.9856,119.0013,60.9984,9.6571,121.9968,19.3142,182.9953,28.9713,.9999-.3335,1.9998-.667,2.9997-1.0005-5.3386-46.6657-10.6771-93.3315-16.0157-139.9972,.9989-9.0001,1.9978-18.0003,2.9967-27.0004-5.6673-7.6658-11.3347-15.3315-17.0019-22.9973-1-.3332-2-.6664-3-.9995-47.6628,14.6741-95.3257,29.3482-142.9885,44.0222Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-65",
    d: "M179.0046,436.0019c60.9985,9.9904,121.9969,19.9809,182.9954,29.9713-5.3324,6.0008-10.6647,12.0016-15.9972,18.0025-5.9995,2.3343-11.9989,4.6685-17.9984,7.0028-1.6658,6.6669-3.3317,13.3338-4.9974,20.0007-1.6664,1.6669-3.3328,3.3338-4.9992,5.0008-.6662,3.6668-1.3325,7.3335-1.9986,11.0003-4.3324,6.334-8.6648,12.668-12.9972,19.002l-3.9998,.0006c-52.9995-15.6584-105.999-31.3167-158.9985-46.9751-1.3334-.9998-2.6667-1.9996-4.0002-2.9994,13.6637-20.0021,27.3275-40.0042,40.9911-60.0063l1.9999-.0003Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-78",
    d: "M179.0046,436.0019c-.3335-.9999-.6668-1.9999-1.0003-2.9998-20.0013-18.3302-40.0025-36.6603-60.0038-54.9905-1.1666-.4998-2.3334-.9996-3.5-1.4994-19.1594,54.1695-38.3189,108.3391-57.4784,162.5086l2.9999-.0005c24.9973-13.3372,49.9946-26.6744,74.992-40.0116,14.6635-21.0022,29.3271-42.0045,43.9906-63.0067Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-124",
    d: "M123.4889,281.5109c-2.9961,31.6671-5.9923,63.3341-8.9884,95.0012,21.5014,19.8299,43.0027,39.6599,64.5041,59.4898,2.9977-18.3338,5.9954-36.6675,8.9931-55.0013-.0023-19.6666-.0046-39.3332-.0069-58.9999,.3333-.6667,.6664-1.3334,.9997-2.0002-4.002-18.666-8.004-37.332-12.006-55.998-.6667-.6666-1.3335-1.3331-2.0001-1.9997-16.6652,6.0026-33.3305,12.0052-49.9957,18.0078-.4999,.5001-.9998,1.0002-1.4998,1.5002Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-102",
    d: "M114.976,168.0125c2.8377,37.8328,5.6753,75.6656,8.513,113.4984,17.4985-6.1694,34.997-12.3388,52.4955-18.5082-20.3362-31.6634-40.6723-63.3268-61.0084-94.9903Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-26",
    d: "M57.0221,539.0207c2,.333,3.9999,.666,5.9999,.9991,25.6667,9.996,51.3334,19.9919,77.0001,29.9879-4.3304,23.334-8.6608,46.6679-12.9912,70.0019-.3333,.6667-.6664,1.3334-.9997,2.0002-23.003-34.3297-46.006-68.6593-69.009-102.989Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-120",
    d: "M137.0135,496.0083c.3336,1.6666,.667,3.3332,1.0005,4.9998,9.0024,23.9985,18.0048,47.9971,27.0073,71.9956,36.6671,17.9942,73.3343,35.9885,110.0015,53.9827,1.6666,.3331,3.3333,.6661,4.9999,.9992,.6661-4.0001,1.3324-8.0002,1.9985-12.0003-1.6675-7.9997-3.3351-15.9994-5.0026-23.9992-.3338-3.9999-.6675-7.9999-1.0014-11.9998,8.9983-11.3347,17.9965-22.6694,26.9948-34.0041-55.3329-16.658-110.6656-33.316-165.9985-49.974Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-145",
    d: "M139.0223,571.0078c.3333-.3334,.6665-.6668,.9998-1.0002,8.333,.332,16.666,.6641,24.999,.9961,.6667,.6666,1.3335,1.3331,2.0001,1.9997,7.3365,28.9988,14.6728,57.9976,22.0092,86.9964-.3333,.3334-.6665,.6668-.9998,1.0002-20.6665-6.3301-41.333-12.6602-61.9995-18.9903,4.3304-23.6673,8.6607-47.3346,12.9911-71.0019Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-62",
    d: "M166.0212,572.0036c38.0005,18.6607,76.001,37.3214,114.0015,55.9821-30.664,11.0048-61.3281,22.0095-91.992,33.0143-7.3365-29.6654-14.6729-59.3309-22.0095-88.9964Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-31",
    d: "M166.0212,572.0036c-8.9996-.3319-17.9993-.6639-26.9989-.9958-.6669-2.9999-1.334-5.9998-2.001-8.9997-.3356-18.9999-.6711-37.9998-1.0067-56.9997,.333-3,.6659-6.0001,.9989-9.0001,9.6692,25.3318,19.3385,50.6635,29.0076,75.9953Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-32",
    d: "M175.9844,263.0027c4.0021,19.666,8.0043,39.332,12.0064,58.998,47.9961-15.3408,95.9921-30.6816,143.9882-46.0224-.6671-4.3332-1.3343-8.6664-2.0014-12.9997,1.9986-11.0003,3.9972-22.0006,5.9959-33.0009-53.3297,11.0083-106.6593,22.0166-159.989,33.0249Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-60",
    d: "M137.0135,496.0083c-26.6638,14.3375-53.3276,28.6749-79.9914,43.0124,27.3334,10.6624,54.6667,21.3247,82.0001,31.9871-.6695-24.9998-1.3392-49.9997-2.0087-74.9995Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "spiked_2_svg__shapes_spikes_color"
  }, /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-140",
    d: "M191,648c.3334-.3333,.6666-.6667,1-1,1-.3333,2-.6667,3-1h3c2.3334,1.3333,4.6666,2.6667,7,4,.6666,.6667,1.3334,1.3333,2,2,.3334,.6667,.6666,1.3333,1,2,1.3334,12.3333,2.6666,24.6667,4,37v5l-21-48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-99",
    d: "M216,651c-.6666-.3333-1.3334-.6667-2-1-2,.3333-4,.6667-6,1-.3334,.3333-.6666,.6667-1,1,1.6666,14.6667,3.3334,29.3333,5,44,1.3334-15,2.6666-30,4-45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-56",
    d: "M183,618h2c2.3334,1.3333,4.6666,2.6667,7,4,.6666,.6667,1.3334,1.3333,2,2,.4838,2.0125,.9674,4.025,1.4512,6.0375,.5162,4.6541,1.0326,9.3083,1.5488,13.9625v2c-2,.6667-4,1.3333-6,2-2.6666-10-5.3334-20-8-30Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-57",
    d: "M194,624c1-.6667,2-1.3333,3-2,3.6666-.6667,7.3334-1.3333,11-2h2c2,10.3333,4,20.6667,6,31-3,.3333-6,.6667-9,1-4.3334-9.3333-8.6666-18.6667-13-28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-77",
    d: "M187,590c.3334,1,.6666,2,1,3l6,30v1c-3.6666-2-7.3334-4-11-6,.3334-8,.6666-16,1-24,1-1.3333,2-2.6667,3-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-21",
    d: "M187,590c7.6666,10,15.3334,20,23,30l-16,4c-2.3334-11.3333-4.6666-22.6667-7-34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-133",
    d: "M370,252c-4-1.6667-8-3.3333-12-5-5.6666,1-11.3334,2-17,3-.3334,5.3333-.6666,10.6667-1,16,4.3334,2.3333,8.6666,4.6667,13,7,3-.3333,6-.6667,9-1,2.6666-6.6667,5.3334-13.3333,8-20Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-92",
    d: "M353,273c-9,11.3333-18,22.6667-27,34,6.6666-4.3333,13.3334-8.6667,20-13,5.3334-7.3333,10.6666-14.6667,16-22-3,.3333-6,.6667-9,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-13",
    d: "M340,266c-5.3334,9-10.6666,18-16,27,.6666,4.6667,1.3334,9.3333,2,14,9-11.3333,18-22.6667,27-34-4.3334-2.3333-8.6666-4.6667-13-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-50",
    d: "M341,250c-5.6666,5.3333-11.3334,10.6667-17,16v27c5.3334-9,10.6666-18,16-27,.3334-5.3333,.6666-10.6667,1-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-122",
    d: "M324,266v27c-4.3334-2-8.6666-4-13-6,4.3334-7,8.6666-14,13-21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-8",
    d: "M326,307c-11.3334-2.6667-22.6666-5.3333-34-8,10.6666-2,21.3334-4,32-6,.6666,4.6667,1.3334,9.3333,2,14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-70",
    d: "M208,493c-7.3334,1.3333-14.6666,2.6667-22,4-1.3334,4.3333-2.6666,8.6667-4,13-.3334,2-.6666,4-1,6,3.6666,3,7.3334,6,11,9h21c6-5.3333,12-10.6667,18-16-1.3334-1.3333-2.6666-2.6667-4-4-6.3334-4-12.6666-8-19-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-142",
    d: "M181,462c3-.6667,6-1.3333,9-2h7c.6666,1,1.3334,2,2,3,3,9.6667,6,19.3333,9,29v2c-7,1.3333-14,2.6667-21,4-.3334-.6667-.6666-1.3333-1-2-1.6666-10.3333-3.3334-20.6667-5-31v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-130",
    d: "M177,469c1.3334,15.6667,2.6666,31.3333,4,47l6-18-6-36c-1.3334,2.3333-2.6666,4.6667-4,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-109",
    d: "M208,494c7.6666,5,15.3334,10,23,15-6.6666-13.3333-13.3334-26.6667-20-40-4.6666-3-9.3334-6-14-9,3.6666,11.3333,7.3334,22.6667,11,34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-2",
    d: "M311,287c4.3334,2,8.6666,4,13,6-10.6666,2-21.3334,4-32,6,6.3334-4,12.6666-8,19-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-44",
    d: "M346,294c-6.6666,4.3333-13.3334,8.6667-20,13,7.6666-2.6667,15.3334-5.3333,23-8-1-1.6667-2-3.3333-3-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-69",
    d: "M260,627c4.3334,18.6667,8.6666,37.3333,13,56l6,3h1c.6666-23.3333,1.3334-46.6667,2-70h-2c-6.3334,3-12.6666,6-19,9-.3334,.6667-.6666,1.3333-1,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-113",
    d: "M264.7618,589.061c-.2539-.0203-.5079-.0406-.7618-.061-4,5.3333-8,10.6667-12,16-.3348,.7468-.6696,1.4936-1.0044,2.2404,.3348,.9199,.6696,1.8398,1.0044,2.7596,2.6666,5,5.3334,10,8,15,.3334,.3333,.6666,.6667,1,1,7-3.3333,14-6.6667,21-10-.6666-1.3333-1.3334-2.6667-2-4-4.6666-7.3333-9.3334-14.6667-14-22-.4127-.313-.8254-.626-1.2382-.939Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-91",
    d: "M230,551v3c2.3334,9.3333,4.6666,18.6667,7,28,.4916,.5591,.9832,1.1181,1.4747,1.6771,1.5374,.1966,2.5251,.3228,2.5253,.3229,.0005-.0002,5.1029-2.5515,10-5,.3334-.3333,.6666-.6667,1-1v-2c-3-8.6667-6-17.3333-9-26-.6666-1.3333-1.3334-2.6667-2-4-.9757,.299-2.0004,.5716-3,1-2.3334,1-4.6666,2-7,3-.3334,.3333-.6666,.6667-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-150",
    d: "M224,616c.6666-.3333,1.3334-.6667,2-1,7.3334-2.3333,14.6666-4.6667,22-7l2.9956-.7596c3.3348,6.2532,6.6696,12.5064,10.0044,18.7596,1.3334,5.6667,2.6666,11.3333,4,17-.6666,.3333-1.3334,.6667-2,1-5.6666-.6667-11.3334-1.3333-17-2-1-.3333-2-.6667-3-1-6.3334-8.3333-12.6666-16.6667-19-25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-119",
    d: "M230,551c2.825,10.8924,5.6498,21.7848,8.4747,32.6771-.4916,.7743-.9832,1.5486-1.4747,2.3229-5.3334,4-10.6666,8-16,12-1,.6667-2,1.3333-3,2,.3334-13.6667,.6666-27.3333,1-41,.6666-.6667,1.3334-1.3333,2-2,2.3334-1.6667,4.6666-3.3333,7-5,.6666-.3333,1.3334-.6667,2-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-3",
    d: "M273,681c-2.6666-12.6667-5.3334-25.3333-8-38-7.3334-.6667-14.6666-1.3333-22-2,7.3334,15,14.6666,30,22,45h1c2.3334-1.3333,4.6666-2.6667,7-4v-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-10",
    d: "M230,551c-3.6666,2.6667-7.3334,5.3333-11,8,1.3334-8,2.6666-16,4-24,1,1.3333,2,2.6667,3,4,1,2.3333,2,4.6667,3,7,.3334,1.6667,.6666,3.3333,1,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-12",
    d: "M273,681c-2.6666,1.6667-5.3334,3.3333-8,5,1.6666,1,3.3334,2,5,3,2,.3333,4,.6667,6,1,1.3334-1.3333,2.6666-2.6667,4-4-2.3334-1.6667-4.6666-3.3333-7-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-68",
    d: "M310,554c-1.6666,3.3333-3.3334,6.6667-5,10l6,9c1.3334-4,2.6666-8,4-12-1.6666-2.3333-3.3334-4.6667-5-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-30",
    d: "M285.5,569.5c-.1666-1.8333-.3334-3.6667-.5-5.5-2.3334-9.3333-4.6666-18.6667-7-28-.3334-.6667-.6666-1.3333-1-2h-1c-2.6666,3-5.3334,6-8,9-.3334,1.3333-.6666,2.6667-1,4l9,33c.6666-.3333,1.3334-.6667,2-1,2.3334-2.3333,4.6666-4.6667,7-7,.1666-.8333,.3334-1.6667,.5-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-97",
    d: "M316,527h-14v2l6,24c.6666,1,1.3334,2,2,3,1.3334,1.6667,2.6666,3.3333,4,5,.6666,.6667,1.3334,1.3333,2,2,3,.6667,6,1.3333,9,2,.6666-.3333,1.3334-.6667,2-1-3.6666-12.3333-7.3334-24.6667-11-37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-53",
    d: "M285.5,569.5c-2.8334-11.8333-5.6666-23.6667-8.5-35.5,1-.6667,2-1.3333,3-2,6.3334-1.6667,12.6666-3.3333,19-5h3c2.6666,9.6667,5.3334,19.3333,8,29-1.3334,2.6667-2.6666,5.3333-4,8-1,.6667-2,1.3333-3,2-5,1.3333-10,2.6667-15,4-.8334-.1667-1.6666-.3333-2.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-115",
    d: "M267,547c3.3334-4.3333,6.6666-8.6667,10-13,.3334-.6667,.6666-1.3333,1-2,.3334-7.3333,.6666-14.6667,1-22-.3334-.6667-.6666-1.3333-1-2l-6,6c-1.6666,11-3.3334,22-5,33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-54",
    d: "M278,508c4.6666,.6667,9.3334,1.3333,14,2l3,3c2.3334,4,4.6666,8,7,12v2c-8.3334,2.3333-16.6666,4.6667-25,7,.3334-8.6667,.6666-17.3333,1-26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-67",
    d: "M292,510c3.6666,1.6667,7.3334,3.3333,11,5,4.3334,4,8.6666,8,13,12h-14c-3.3334-5.6667-6.6666-11.3333-10-17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-112",
    d: "M285.5,569.5c.1666,1.5,.3334,3,.5,4.5,4.3334,9,8.6666,18,13,27,.6666,.6667,1.3334,1.3333,2,2,1.3334,.3333,2.6666,.6667,4,1,3.3334-.3333,6.6666-.6667,10-1,.6666-.3333,1.3334-.6667,2-1v-3c-1.6666-8.6667-3.3334-17.3333-5-26-.3334-.6667-.6666-1.3333-1-2-1.6666-2.3333-3.3334-4.6667-5-7-6.8334,1.8333-13.6666,3.6667-20.5,5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-27",
    d: "M311,571c1-3.3333,2-6.6667,3-10,4.3334,1,8.6666,2,13,3-1.3334,13.6667-2.6666,27.3333-4,41h-2c-1-.6667-2-1.3333-3-2-.3334-.3333-.6666-.6667-1-1-2-10.3333-4-20.6667-6-31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-100",
    d: "M276,580c6,8.6667,12,17.3333,18,26h2c1.3334-.6667,2.6666-1.3333,4-2,.3334-.3333,.6666-.6667,1-1-5.1666-11.1667-10.3334-22.3333-15.5-33.5-3.1666,3.5-6.3334,7-9.5,10.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-139",
    d: "M323,605l-6-3c-.3334,.6667-.6666,1.3333-1,2,.3334,4,.6666,8,1,12,.3334,.6667,.6666,1.3333,1,2,1.6666-4.3333,3.3334-8.6667,5-13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-63",
    d: "M301,603c5.3334-.3333,10.6666-.6667,16-1,.3334,5.3333,.6666,10.6667,1,16l-4,1c-.6666-.6667-1.3334-1.3333-2-2-3.3334-4-6.6666-8-10-12-.3334-.6667-.6666-1.3333-1-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-98",
    d: "M301,603c4.3334,5.3333,8.6666,10.6667,13,16-2-.6667-4-1.3333-6-2-4.6666-3.6667-9.3334-7.3333-14-11,2.3334-1,4.6666-2,7-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-134",
    d: "M323,474c-9.6666-5.3333-19.3334-10.6667-29-16,.6666-4.6667,1.3334-9.3333,2-14l27,30Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-141",
    d: "M318.5,437.5c-4.5-.1667-9-.3333-13.5-.5,6,12.3333,12,24.6667,18,37-1.5-12.1667-3-24.3333-4.5-36.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-47",
    d: "M282,402c7.6666,11.6667,15.3334,23.3333,23,35,4.5,.1667,9,.3333,13.5,.5-3.8334-9.5-7.6666-19-11.5-28.5-8.3334-2.3333-16.6666-4.6667-25-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-25",
    d: "M275.5,440.5c6.1666,5.8333,12.3334,11.6667,18.5,17.5,.6666-4.6667,1.3334-9.3333,2-14-7.3334-8.3333-14.6666-16.6667-22-25,.5,7.1667,1,14.3333,1.5,21.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-93",
    d: "M392,503c-2.3334,2.3333-4.6666,4.6667-7,7,.6666,2.6667,1.3334,5.3333,2,8,.3334,.6667,.6666,1.3333,1,2,3-.6667,6-1.3333,9-2,1.5-1.8333,3-3.6667,4.5-5.5,.5-2.1667,1-4.3333,1.5-6.5-.6666-.3333-1.3334-.6667-2-1-3-.6667-6-1.3333-9-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-42",
    d: "M342,459c.6666,1,1.3334,2,2,3,13.6666,16,27.3334,32,41,48h1c2.3334-2,4.6666-4,7-6-.3334-1-.6666-2-1-3-13.6666-19.6667-27.3334-39.3333-41-59-1-.6667-2-1.3333-3-2-.6666,.3333-1.3334,.6667-2,1-1.3334,4.6667-2.6666,9.3333-4,14v4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-43",
    d: "M342,459c1.5,8.1667,3,16.3333,4.5,24.5,13.8334,12.1667,27.6666,24.3333,41.5,36.5-.6666-3.3333-1.3334-6.6667-2-10-14.6666-17-29.3334-34-44-51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-79",
    d: "M368,432h-4c-5,2.3333-10,4.6667-15,7-.3334,.3333-.6666,.6667-1,1,15,21.3333,30,42.6667,45,64,3.3334,.6667,6.6666,1.3333,10,2-11.6666-24.6667-23.3334-49.3333-35-74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-143",
    d: "M348,411c-.6666,.6667-1.3334,1.3333-2,2-1.3334,2.6667-2.6666,5.3333-4,8-.3334,1.3333-.6666,2.6667-1,4,.3334,1,.6666,2,1,3,1.6666,3.6667,3.3334,7.3333,5,11,.3334,.3333,.6666,.6667,1,1,6.6666-2.6667,13.3334-5.3333,20-8-6.6666-7-13.3334-14-20-21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-131",
    d: "M330,437c4,7.3333,8,14.6667,12,22,2-6.3333,4-12.6667,6-19-2.3334-5-4.6666-10-7-15-.6666,.3333-1.3334,.6667-2,1-2.6666,3-5.3334,6-8,9-.3334,.6667-.6666,1.3333-1,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-14",
    d: "M320,407c1.3334,1.3333,2.6666,2.6667,4,4,5.3334,4.6667,10.6666,9.3333,16,14h1c2.3334-4.6667,4.6666-9.3333,7-14-9.3334-1.3333-18.6666-2.6667-28-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-149",
    d: "M320,407c3.3334,10,6.6666,20,10,30,3.6666-4,7.3334-8,11-12l-21-18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-86",
    d: "M351,505c-.6666,.3333-1.3334,.6667-2,1h-6c-1-.3333-2-.6667-3-1-.6666-.3333-1.3334-.6667-2-1-4-3.6667-8-7.3333-12-11-.6666-1-1.3334-2-2-3,.6666-.3333,1.3334-.6667,2-1,1.6666-.3333,3.3334-.6667,5-1h4c5.3334,5.6667,10.6666,11.3333,16,17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-72",
    d: "M340,505c-.3334,1-.6666,2-1,3-1.6666,2-3.3334,4-5,6-.6666,.3333-1.3334,.6667-2,1-.6666-.3333-1.3334-.6667-2-1-4.6666-4-9.3334-8-14-12-.3334-1-.6666-2-1-3l9-9c5.3334,5,10.6666,10,16,15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-55",
    d: "M332,515c.0941,.7255,.1881,1.4509,.2822,2.1764-.4274,1.2745-.8549,2.5491-1.2822,3.8236-.6666,.6667-1.3334,1.3333-2,2-5.8334-5.8333-11.6666-11.6667-17.5-17.5,.1666-.8333,.3334-1.6667,.5-2.5,.3334-1,.6666-2,1-3,.6666-.3333,1.3334-.6667,2-1,5.6666,5.3333,11.3334,10.6667,17,16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-146",
    d: "M340,505c-2.6666,3.3333-5.3334,6.6667-8,10l3,3c4.6666,3,9.3334,6,14,9,2.6666,1,5.3334,2,8,3-1.8613-3.2572-3.8579-6.5962-6-10-2.6698-4.2424-5.3489-8.2413-8-12l-3-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-52",
    d: "M340,505h11c2,8.3333,4,16.6667,6,25-5.6666-8.3333-11.3334-16.6667-17-25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-73",
    d: "M329,523c1-2.6667,2-5.3333,3-8,8.3334,5,16.6666,10,25,15-9.3334-2.3333-18.6666-4.6667-28-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-111",
    d: "M324,490l-9,9c-.6666-.3333-1.3334-.6667-2-1-2.3334-3.6667-4.6666-7.3333-7-11-1.6666-3-3.3334-6-5-9,1.6666,.3333,3.3334,.6667,5,1,5.3334,2.6667,10.6666,5.3333,16,8,.6666,1,1.3334,2,2,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-74",
    d: "M315,499c-1.1666,2.1667-2.3334,4.3333-3.5,6.5-3.5-9.1667-7-18.3333-10.5-27.5,4.6666,7,9.3334,14,14,21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-135",
    d: "M301,478c7.6666,4,15.3334,8,23,12,3.6666-.6667,7.3334-1.3333,11-2-8.6666-3.3333-17.3334-6.6667-26-10h-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-125",
    d: "M238.4747,583.6771c-6.825,5.4409-13.6498,10.8819-20.4747,16.3229,2,5.3333,4,10.6667,6,16,8.9985-2.9199,17.9971-5.8398,26.9956-8.7596-.3319-1.0801-.6637-2.1602-.9956-3.2404-6.5131-12.3748-10-19-10-19,0,0-.0654-.0567-1.5253-1.3229Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-123",
    d: "M241,546c9.3334,13.3333,18.6666,26.6667,28,40v1c-1,.6667-2,1.3333-3,2l-1.2382,.061c-.5873-.3537-1.1746-.7073-1.7618-1.061-6.5037-5.2029-10-8-10-8,0,0-.0267-.0535-1-2-3.6666-10.6667-7.3334-21.3333-11-32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-121",
    d: "M269,586c-1.4127,1.0203-2.8254,2.0406-4.2382,3.061,5.7461,8.9797,11.4921,17.9594,17.2382,26.939-4.3334-10-8.6666-20-13-30Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-95",
    d: "M252,578c-4.5084,1.8924-9.0168,3.7848-13.5253,5.6771,4.1736,7.8544,8.3473,15.7088,12.5209,23.5632,4.5887-6.0598,9.1775-12.1196,13.7662-18.1794-4.2539-3.687-8.5079-7.374-12.7618-11.061Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-101",
    d: "M207,652c-3.3334-2-6.6666-4-10-6-1-7.3333-2-14.6667-3-22,4.3334,9.3333,8.6666,18.6667,13,28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-39",
    d: "M247,456c.3334,1.3333,.6666,2.6667,1,4,3.3334,5.6667,6.6666,11.3333,10,17,4-.6667,8-1.3333,12-2,.3334-.3333,.6666-.6667,1-1-1.3334-3.3333-2.6666-6.6667-4-10-6.6666-2.6667-13.3334-5.3333-20-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-23",
    d: "M247,456c3.6666,6.3333,7.3334,12.6667,11,19-.3334,1-.6666,2-1,3-2.7877,2.6021-5.5753,5.2042-8.363,7.8063-1.2123,.3979-2.4247,.7958-3.637,1.1937l-3-18c1.6666-4.3333,3.3334-8.6667,5-13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-41",
    d: "M258,475c.6666,1.3333,1.3334,2.6667,2,4,3.3334,4.6667,6.6666,9.3333,10,14,1.1666,1.1667,2.3334,2.3333,3.5,3.5-.8334-7.5-1.6666-15-2.5-22.5-4.3334,.3333-8.6666,.6667-13,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-7",
    d: "M258,475c5.1666,7.1667,10.3334,14.3333,15.5,21.5-9.5-3.1667-19-6.3333-28.5-9.5,4.3334-4,8.6666-8,13-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-89",
    d: "M189,554c-3.3334,1-6.6666,2-10,3h-3c2.6666-7.3333,5.3334-14.6667,8-22,.6666,1.6667,1.3334,3.3333,2,5,1,4.6667,2,9.3333,3,14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-106",
    d: "M196,557c-4-7.3333-8-14.6667-12-22,1.3334,6,2.6666,12,4,18,.3334,.3333,.6666,.6667,1,1l6,3h1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-17",
    d: "M188,553v2c.3334,4,.6666,8,1,12,.3334,1,.6666,2,1,3,2-4.3333,4-8.6667,6-13-2.6666-1.3333-5.3334-2.6667-8-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-96",
    d: "M188,553c-4,1.3333-8,2.6667-12,4,4.6666,4.3333,9.3334,8.6667,14,13-.6666-5.6667-1.3334-11.3333-2-17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-46",
    d: "M282,402c7.6666,11.6667,15.3334,23.3333,23,35-3,2.3333-6,4.6667-9,7-7.3334-8.3333-14.6666-16.6667-22-25,2.6666-5.6667,5.3334-11.3333,8-17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-49",
    d: "M305,437c-3,2.3333-6,4.6667-9,7l27,30c-6-12.3333-12-24.6667-18-37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-37",
    d: "M387,405v5c-1.6666,1.6667-3.3334,3.3333-5,5-1.3334,.3333-2.6666,.6667-4,1-.3247-.2447-.6785-.5703-1-1-1.1692-1.5623-1.0664-3.3691-1-4,1.6666-2.3333,3.3334-4.6667,5-7h4c.6666,.3333,1.3334,.6667,2,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-1",
    d: "M356,394c-.3334,.3333-.6666,.6667-1,1-.3334,2.6667-.6666,5.3333-1,8v2c8,3.6667,16,7.3333,24,11-.3334-1.6667-.6666-3.3333-1-5v-1c-1-2.6667-2-5.3333-3-8-5.3334-2.6667-10.6666-5.3333-16-8h-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-15",
    d: "M366,386c-3.3334,2.6667-6.6666,5.3333-10,8,5.6666,2.6667,11.3334,5.3333,17,8,1,.6667,2,1.3333,3,2,1.3334,.3333,2.6666,.6667,4,1h7c-7-6.3333-14-12.6667-21-19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-19",
    d: "M344,382c.6666,.3333,1.3334,.6667,2,1l9,9c.3334,.6667,.6666,1.3333,1,2-.6666,3.6667-1.3334,7.3333-2,11-4.6666-3-9.3334-6-14-9v-1l3-12c.3334-.3333,.6666-.6667,1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-80",
    d: "M356,375h-2l-9,6c-.3334,.3333-.6666,.6667-1,1l12,12c3.3334-2.6667,6.6666-5.3333,10-8-3.3334-3.6667-6.6666-7.3333-10-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-22",
    d: "M344,382c4-2.3333,8-4.6667,12-7-4.6666-2-9.3334-4-14-6-1.6666,.3333-3.3334,.6667-5,1,.3334,1,.6666,2,1,3,1.6666,3,3.3334,6,5,9h1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-90",
    d: "M340,396c1.3334-4.6667,2.6666-9.3333,4-14-2.3334-4-4.6666-8-7-12-.7018,.9739-1.4037,1.9477-2.1055,2.9216,.0352,3.3595,.0703,6.719,.1055,10.0784,1.6666,4.3333,3.3334,8.6667,5,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-81",
    d: "M360,352c-.6666-.3333-1.3334-.6667-2-1-4.3334-.3333-8.6666-.6667-13-1,6,5.6667,12,11.3333,18,17,.6666,.3333,1.3334,.6667,2,1-1.6666-5.3333-3.3334-10.6667-5-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-107",
    d: "M347,351c6,5.6667,12,11.3333,18,17-6.1666-2.8333-12.3334-5.6667-18.5-8.5-.1666-.1667-.3334-.3333-.5-.5v-7c.3334-.3333,.6666-.6667,1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-126",
    d: "M333,339c-.6666,4.3333-1.3334,8.6667-2,13,1.3334,2.6667,2.6666,5.3333,4,8,.3334-.3333,.6666-.6667,1-1,3-4.6667,6-9.3333,9-14l-12-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-20",
    d: "M343,345l3,6h1c4.3334,.3333,8.6666,.6667,13,1-3.1666-3.5-6.3334-7-9.5-10.5-.8334-.1667-1.6666-.3333-2.5-.5-1.3334,1-2.6666,2-4,3-.3334,.3333-.6666,.6667-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-87",
    d: "M333,339c3.3334,2,6.6666,4,10,6,2.5-1.1667,5-2.3333,7.5-3.5-3.8334-1.5-7.6666-3-11.5-4.5-2,.6667-4,1.3333-6,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-64",
    d: "M343,345c-2.6666,5-5.3334,10-8,15,3.8334-.1667,7.6666-.3333,11.5-.5,.1666-2.8333,.3334-5.6667,.5-8.5-1.3334-2-2.6666-4-4-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-18",
    d: "M324.5023,318.3057l.347,1.9697c2.0462,2.0088,4.0925,4.0176,6.1386,6.0264,.7143,.2126,1.4288,.4252,2.1432,.6378-.4813-4.6537-.9628-9.3074-1.4441-13.9612-2.3949,1.7758-4.7898,3.5515-7.1847,5.3273Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-136",
    d: "M324.5023,318.3057c2.8763,2.878,5.7525,5.7559,8.6288,8.6339l-11.818,2.0819c1.063-3.5719,2.1262-7.1439,3.1892-10.7158Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-128",
    d: "M259,423c-3.6666-6.6667-7.3334-13.3333-11-20,.3334-3.3333,.6666-6.6667,1-10,.6666,1.3333,1.3334,2.6667,2,4,2.3334,7.3333,4.6666,14.6667,7,22,.3334,1.3333,.6666,2.6667,1,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-45",
    d: "M249,393c3.3334,10,6.6666,20,10,30-.6666-8-1.3334-16-2-24-2.6666-2-5.3334-4-8-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-116",
    d: "M258,361c-1.3334,2.3333-2.6666,4.6667-4,7,1.3334,2.3333,2.6666,4.6667,4,7,3.3334,.6667,6.6666,1.3333,10,2l6-6c-1.3334-2.6667-2.6666-5.3333-4-8-4-.6667-8-1.3333-12-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-24",
    d: "M271,354c-4.3334,2.3333-8.6666,4.6667-13,7,4,.6667,8,1.3333,12,2,.3334-3,.6666-6,1-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-129",
    d: "M270,363c1.3334,2.6667,2.6666,5.3333,4,8v-9c-1-2.6667-2-5.3333-3-8-.3334,3-.6666,6-1,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-94",
    d: "M307,374v1c1.3334,4,2.6666,8,4,12,.6666,1,1.3334,2,2,3,.5-5.3333,1-10.6667,1.5-16-.5-.3333-1-.6667-1.5-1h-5c-.3334,.3333-.6666,.6667-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-34",
    d: "M307,374h-2c-2.3334,.3333-4.6666,.6667-7,1-.3334,.3333-.6666,.6667-1,1,5.3334,4.6667,10.6666,9.3333,16,14-2-5.3333-4-10.6667-6-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-4",
    d: "M307,374h7.5c-.5-4.6667-1-9.3333-1.5-14h-1c-2.3334,1.3333-4.6666,2.6667-7,4,.3334,2.6667,.6666,5.3333,1,8,.3334,.6667,.6666,1.3333,1,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-40",
    d: "M306,364c-.6666-.3333-1.3334-.6667-2-1h-7v13c3.3334-.6667,6.6666-1.3333,10-2-.3334-3.3333-.6666-6.6667-1-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-108",
    d: "M293.5,349.5c.8323,.8142,1.6659,1.6474,2.5,2.5,3.2766,3.3491,6.2684,6.6988,9,10,.3334,.6667,.6666,1.3333,1,2-3-.3333-6-.6667-9-1-1.1666-4.5-2.3334-9-3.5-13.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-76",
    d: "M293.5,349.5c4.1666,4.8333,8.3334,9.6667,12.5,14.5,2.3334-1.3333,4.6666-2.6667,7-4l-19.5-10.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-114",
    d: "M272,315c-.3334,.3333-.6666,.6667-1,1-1.3334,2.6667-2.6666,5.3333-4,8,5,3.6667,10,7.3333,15,11,.6666,.3333,1.3334,.6667,2,1l-12-21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-11",
    d: "M268,324h-1c-1.6666,.6667-3.3334,1.3333-5,2-.3334,.3333-.6666,.6667-1,1,7.6666,3,15.3334,6,23,9-5.3334-4-10.6666-8-16-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-35",
    d: "M258,317c.6666,.3333,1.3334,.6667,2,1,2.6666,1.6667,5.3334,3.3333,8,5v1c-2.3334,1-4.6666,2-7,3-1-3.3333-2-6.6667-3-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-88",
    d: "M272,315c-4.6666,.6667-9.3334,1.3333-14,2,3.3334,2.3333,6.6666,4.6667,10,7,1.3334-3,2.6666-6,4-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-5",
    d: "M226,320c.3334,1,.6666,2,1,3,1.6666,3.3333,3.3334,6.6667,5,10,.6666,.6667,1.3334,1.3333,2,2,.6666-1.3333,1.3334-2.6667,2-4v-1c-3.3334-3.3333-6.6666-6.6667-10-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-85",
    d: "M233,334c1-1.3333,2-2.6667,3-4,1,12.3333,2,24.6667,3,37-.3334-1.3333-.6666-2.6667-1-4-1.6666-9-3.3334-18-5-27v-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-84",
    d: "M233,334c-.3334,.3333-.6666,.6667-1,1-3.3334,1.6667-6.6666,3.3333-10,5h-2c2-6.6667,4-13.3333,6-20,2.3334,4.6667,4.6666,9.3333,7,14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-127",
    d: "M220,340c4.3334-2,8.6666-4,13-6l6,33c-6.3334-9-12.6666-18-19-27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-151",
    d: "M214,376c-4.3334,.3333-8.6666,.6667-13,1,5,4.3333,10,8.6667,15,13-.6666-4.6667-1.3334-9.3333-2-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-104",
    d: "M204,357c1.7888,3.0787,3.5836,6.3153,5.364,9.7095,1.6627,3.1699,3.205,6.2713,4.636,9.2905-4.3334,.3333-8.6666,.6667-13,1,1-6.6667,2-13.3333,3-20Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-138",
    d: "M204,357c3.3334,6.3333,6.6666,12.6667,10,19,1.3334-1,2.6666-2,4-3-4.6666-5.3333-9.3334-10.6667-14-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-66",
    d: "M214,376c.6666,4.6667,1.3334,9.3333,2,14,.6666-5.6667,1.3334-11.3333,2-17-1.3334,1-2.6666,2-4,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-58",
    d: "M233,433c-.3334-.3333-.6666-.6667-1-1-4.6666-2.6667-9.3334-5.3333-14-8,.6666,4,1.3334,8,2,12,.3334,1,.6666,2,1,3,3.3334,.6667,6.6666,1.3333,10,2,.6666-2.6667,1.3334-5.3333,2-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-132",
    d: "M208,409c.8691,3.4766,1,4,1,4l9,12h1c4.6666,2.6667,9.3334,5.3333,14,8-2.3334-6.3333-4.6666-12.6667-7-19-6-1.6667-12-3.3333-18-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-137",
    d: "M208,409c.6666,6.6667,1.3334,13.3333,2,20,3.6666,3.3333,7.3334,6.6667,11,10-.6666-4.6667-1.3334-9.3333-2-14-3.6666-5.3333-7.3334-10.6667-11-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-117",
    d: "M170.5095,654.8217c-2.8365-2.2739-5.673-4.5478-8.5095-6.8217h-12c-3.3334,2.6667-6.6666,5.3333-10,8l9,9c5-.6667,10-1.3333,15-2,2.1698-2.7261,4.3397-5.4522,6.5095-8.1783Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-29",
    d: "M160,624c.6666,8,1.3334,16,2,24,2.8365,2.2739,5.673,4.5478,8.5095,6.8217-1.1698-6.2739-2.3397-12.5478-3.5095-18.8217-2.3334-4-4.6666-8-7-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-82",
    d: "M153,622c-2.3334,2.3333-4.6666,4.6667-7,7l-6,27c3.3334-2.6667,6.6666-5.3333,10-8,1-8.6667,2-17.3333,3-26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-59",
    d: "M153,622c2.3334,.6667,4.6666,1.3333,7,2,.6666,8,1.3334,16,2,24h-12c1-8.6667,2-17.3333,3-26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-105",
    d: "M155,600h-1c-3.3334-2.3333-6.6666-4.6667-10-7-.3334-.3333-.6666-.6667-1-1,4.3334-2.6667,8.6666-5.3333,13-8-.3334,5.3333-.6666,10.6667-1,16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-28",
    d: "M156,584c-.3334,5.3333-.6666,10.6667-1,16h1c1.6666-1.3333,3.3334-2.6667,5-4,.3334-.3333,.6666-.6667,1-1-2-3.6667-4-7.3333-6-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-83",
    d: "M155,600c-4-2.6667-8-5.3333-12-8,1.3334,7.3333,2.6666,14.6667,4,22,.3334-.3333,.6666-.6667,1-1,2.3334-4,4.6666-8,7-12v-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-16",
    d: "M155,600c2.3334-1.6667,4.6666-3.3333,7-5l-3,15c-.3334-.3333-.6666-.6667-1-1-1-2.6667-2-5.3333-3-8v-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-51",
    d: "M155,600c1.3334,3.3333,2.6666,6.6667,4,10-4,1.3333-8,2.6667-12,4,2.6666-4.6667,5.3334-9.3333,8-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-48",
    d: "M381,405c-1.3334,2-2.6666,4-4,6-1.3334-3-2.6666-6-4-9,2.6666,1,5.3334,2,8,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-118",
    d: "M241,546c-3.6666,1.6667-7.3334,3.3333-11,5-2.3334-5.3333-4.6666-10.6667-7-16,6,3.6667,12,7.3333,18,11Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "spiked_2_svg__highlights-5",
    "data-name": "highlights",
    className: "spiked_2_svg__cls-75"
  }, /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-148",
    d: "M167,30c-8.3334,9-16.6666,18-25,27,3.6666,5.6667,7.3334,11.3333,11,17l-12-15c-2.6666,9.6667-5.3334,19.3333-8,29,2.3334-10.3333,4.6666-20.6667,7-31l27-27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-148",
    d: "M240,80c7,3.3333,14,6.6667,21,10-12.3334,4.6667-24.6666,9.3333-37,14,14-4.6667,28-9.3333,42-14-8.6666-3.3333-17.3334-6.6667-26-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-148",
    d: "M308,175c7.6666,17.6667,15.3334,35.3333,23,53-26.6666,6.3333-53.3334,12.6667-80,19,28.3334-5.6667,56.6666-11.3333,85-17-9.3334-18.3333-18.6666-36.6667-28-55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-148",
    d: "M119,223v55c-22.3334,10.3333-44.6666,20.6667-67,31,23.6666-9,47.3334-18,71-27-1.3334-19.6667-2.6666-39.3333-4-59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-148",
    d: "M15,308c-3.6666,6-7.3334,12-11,18,8.3334-2.6667,16.6666-5.3333,25-8-8,3.3333-16,6.6667-24,10,23.6666,11,47.3334,22,71,33-25.3334-10.6667-50.6666-21.3333-76-32l15-21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-148",
    d: "M89,448c-10,28.6667-20,57.3333-30,86-4.3334-25.3333-8.6666-50.6667-13-76,3.6666,27,7.3334,54,11,81,23.3207,35.757,36.3986,53.6942,36,53-10.3334-18-20.6666-36-31-54l27-90Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-148",
    d: "M144,404c11,10.6667,22,21.3333,33,32-13.3334,20-26.6666,40-40,60,14.3334-19.6667,28.6666-39.3333,43-59,12,1.6667,24,3.3333,36,5-12.3334-2.6667-24.6666-5.3333-37-8-11.6666-10-23.3334-20-35-30Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-148",
    d: "M177,20c6-5.3333,12-10.6667,18-16-.6666,15.3333-1.3334,30.6667-2,46,1.3334-16.6667,2.6666-33.3333,4-50-6.6666,6.6667-13.3334,13.3333-20,20Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-148",
    d: "M180,283l6,39c.6666,8.3333,1.3334,16.6667,2,25v-25c-2.6666-13-5.3334-26-8-39Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "spiked_2_svg__highlights_spikes",
    className: "spiked_2_svg__cls-75"
  }, /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-148",
    d: "M151,627c.1656,.0124-.1678,6.6806-1,20h11c-.1664-9.9934-.1664-14.9944,0-15,.1665-.0056,.4999,4.9937,1,15,5.4891,5.1577,8.1554,7.824,8,8-.156,.1767-3.1565-2.157-9-7h-11c-3.3334,3-6.6666,6-10,9,3-3.3333,6-6.6667,9-10,1.1676-13.3473,1.8341-20.0125,2-20Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-148",
    d: "M144,661c1.6666,2,3.3334,4,5,6,5-1.3333,10-2.6667,15-4l-15,3c-1.6666-1.6667-3.3334-3.3333-5-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-148",
    d: "M201,472c1.6666,7,3.3334,14,5,21l-18,3c-2-8.3333-4-16.6667-6-25,1.3334,8.6667,2.6666,17.3333,4,26-1.3334,5-2.6666,10-4,15,2-4.3333,4-8.6667,6-13,6.6666-1.3333,13.3334-2.6667,20-4,6,3.6667,12,7.3333,18,11-6-4.3333-12-8.6667-18-13-2.3334-7-4.6666-14-7-21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-148",
    d: "M212,414c-.1942,.1267,2.1395,4.1273,7,12,.3334,3,.6666,6,1,9v-9c2.6666,1.3333,5.3334,2.6667,8,4-2.6666-1.6667-5.3334-3.3333-8-5-5.1416-7.4593-7.8079-11.1254-8-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-148",
    d: "M250,461c2.6666,4.3333,5.3334,8.6667,8,13h7c-2,.3333-4,.6667-6,1l6,9c-2.3334-2.6667-4.6666-5.3333-7-8-3.3334,2.6667-6.6666,5.3333-10,8l9-9c-2.3334-4.6667-4.6666-9.3333-7-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-148",
    d: "M239,585l9,21-12,6c4.3334-1.3333,8.6666-2.6667,13-4,3,4.3333,6,8.6667,9,13-2.3334-4.6667-4.6666-9.3333-7-14,3.3334-4.3333,6.6666-8.6667,10-13-3.6666,3.6667-7.3334,7.3333-11,11-3.6666-6.6667-7.3334-13.3333-11-20Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-148",
    d: "M266,647c2,11.3333,4,22.6667,6,34-2,1.3333-4,2.6667-6,4,2.3334-1,4.6666-2,7-3l6,3c-1.6666-1.3333-3.3334-2.6667-5-4-2.6666-11.3333-5.3334-22.6667-8-34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-148",
    d: "M186,544c.3334,3,.6666,6,1,9-2.6666,1-5.3334,2-8,3,2.6666-.6667,5.3334-1.3333,8-2,.6666,2.6667,1.3334,5.3333,2,8-.3334-2.6667-.6666-5.3333-1-8,2,.6667,4,1.3333,6,2l-6-3c-.6666-3-1.3334-6-2-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-148",
    d: "M258,361c3.6666,.3333,7.3334,.6667,11,1,.6666-2,1.3334-4,2-6-.3334,2.3333-.6666,4.6667-1,7l3,6c-1.3334-2-2.6666-4-4-6-3.6666-.6667-7.3334-1.3333-11-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-148",
    d: "M335,340c2.6666,1.3333,5.3334,2.6667,8,4,2.3334-.6667,4.6666-1.3333,7-2l-6,3,3,6c-1.3334-1.6667-2.6666-3.3333-4-5-1,1.6667-2,3.3333-3,5,.6666-2,1.3334-4,2-6-2.3334-1.6667-4.6666-3.3333-7-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-148",
    d: "M292,418c.3027-.2126,4.9701,5.7884,14,18,3.3334,.3333,6.6666,.6667,10,1-3.3334,.3333-6.6666,.6667-10,1l-9,6c-.6666,3.3333-1.3334,6.6667-2,10v-9c-3.6666-5-7.3334-10-11-15l12,12c2.6666-1.6667,5.3334-3.3333,8-5-8.301-12.4565-12.3004-18.7889-12-19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-148",
    d: "M372,475s6.8698,9.9612,20,29c-4.0756,3.919-6.0841,6.0721-6,6,2.3334-2,4.6666-4,7-6,3.3334,.6667,6.6666,1.3333,10,2-3.3334-1-6.6666-2-10-3-14.2063-18.9417-21-28-21-28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-148",
    d: "M358,422c2.6666,3.3333,5.3334,6.6667,8,10-3.6666,1.6667-7.3334,3.3333-11,5,4-1.3333,8-2.6667,12-4,3,5.3333,6,10.6667,9,16-2.6666-5.6667-5.3334-11.3333-8-17-3.3334-3.3333-6.6666-6.6667-10-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-148",
    d: "M341,377c.6666,1.6667,1.3334,3.3333,2,5-.3334,2.3333-.6666,4.6667-1,7,.6666-2.3333,1.3334-4.6667,2-7,1.6666-1,3.3334-2,5-3-1.6666,.6667-3.3334,1.3333-5,2-1-1.3333-2-2.6667-3-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-148",
    d: "M351,389c1.3334,1.6667,2.6666,3.3333,4,5v7c.3334-2.3333,.6666-4.6667,1-7-1.6666-1.6667-3.3334-3.3333-5-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-148",
    d: "M361,390c1.6666-1,3.3334-2,5-3,3.3334,2.6667,6.6666,5.3333,10,8-3.3334-3-6.6666-6-10-9-1.6666,1.3333-3.3334,2.6667-5,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-148",
    d: "M380,405l-3,6c1.3334-2,2.6666-4,4-6-2.6666-1-5.3334-2-8-3,2.3334,1,4.6666,2,7,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-148",
    d: "M384,405c.6666,.3333,1.3334,.6667,2,1v4c-1.3334,1.6667-2.6666,3.3333-4,5,1.6666-1.6667,3.3334-3.3333,5-5v-5h-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-148",
    d: "M341,250c-.3334,5.3333-.6666,10.6667-1,16,1-4.6667,2-9.3333,3-14,5-1.6667,10-3.3333,15-5-5.6666,1-11.3334,2-17,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-148",
    d: "M332,259c-2.3334,2.6667-4.6666,5.3333-7,8-.3334,4.3333-.6666,8.6667-1,13v-12c-3.6666,5.3333-7.3334,10.6667-11,16,3.6666-6,7.3334-12,11-18,2.6666-2.3333,5.3334-4.6667,8-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-148",
    d: "M229,326c1,2.6667,2,5.3333,3,8-2.6666,1.3333-5.3334,2.6667-8,4l9-3c1.3334,8.3333,2.6666,16.6667,4,25l-3-27c-1.6666-2.3333-3.3334-4.6667-5-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-148",
    d: "M312,483l12,6c3.3334-.3333,6.6666-.6667,10-1-2.6666,.6667-5.3334,1.3333-8,2,1.3334,2,2.6666,4,4,6-2-1.6667-4-3.3333-6-5-4-2.6667-8-5.3333-12-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-148",
    d: "M324,507c2.6666,2.3333,5.3334,4.6667,8,7,2-2.3333,4-4.6667,6-7-1.6666,2.6667-3.3334,5.3333-5,8,3.3334,2,6.6666,4,10,6-3.6666-1.6667-7.3334-3.3333-11-5-2.6666-3-5.3334-6-8-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-148",
    d: "M309,558c-1,1.6667-2,3.3333-3,5-2.6666,1-5.3334,2-8,3,2.6666-.6667,5.3334-1.3333,8-2,1.3334,2,2.6666,4,4,6l-3-6c.6666-2,1.3334-4,2-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-148",
    d: "M298,520c1.3334,2.6667,2.6666,5.3333,4,8l3,9c-.6666-3-1.3334-6-2-9,3-.3333,6-.6667,9-1h-9c-1.6666-2.3333-3.3334-4.6667-5-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-148",
    d: "M279,543c-.3334-3-.6666-6-1-9v-26c-.3334,8.6667-.6666,17.3333-1,26,.6666,3,1.3334,6,2,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-148",
    d: "M146,594c2.6666,2,5.3334,4,8,6-1.3334,3-2.6666,6-4,9,1.6666-3,3.3334-6,5-9,.3334-5.3333,.6666-10.6667,1-16-.6666,5-1.3334,10-2,15-2.6666-1.6667-5.3334-3.3333-8-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-148",
    d: "M306,364v10c-1.6666,.3333-3.3334,.6667-5,1h5c1,1.6667,2,3.3333,3,5-.6666-2-1.3334-4-2-6-.3334-3.3333-.6666-6.6667-1-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-148",
    d: "M190,605c1.6666,6,3.3334,12,5,18l15-3-16,4c-3.6666-2-7.3334-4-11-6,3.6666,1.6667,7.3334,3.3333,11,5-1.3334-6-2.6666-12-4-18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-148",
    d: "M207,652c3-.3333,6-.6667,9-1l-8,2c.6666,8,1.3334,16,2,24-1-8.3333-2-16.6667-3-25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spiked_2_svg__cls-148",
    d: "M205,377c2.3334-.6667,4.6666-1.3333,7-2l-3-9c1.6666,3.3333,3.3334,6.6667,5,10-3,.3333-6,.6667-9,1Z"
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgSpiked2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/spiked_2.4d82a5ab02c72c582393eb55df8bdc82.svg";